import {
  InfoPopoverExampleCaption,
  InfoPopoverExamplesGrid,
  InfoPopoverExampleValue,
  InfoPopoverExampleValueBox,
  InfoPopoverText,
} from '@framework/ui/components/popover/InfoPopoverContent.tsx';
import styled from 'styled-components';
import { ColSpanExampleTwoOne } from './ColSpanExampleTwoOne.tsx';
import { ColSpanExampleTwoThree } from './ColSpanExampleTwoThree.tsx';

const ColSpanContentWrapper = styled.div`
  max-width: 400px;
`;
/**
 * Contenuto del popover ⓘ del campo "Numero colonne": spiega il riparto
 * proporzionale della Riga con due esempi illustrati (valore 2 accanto a
 * un campo con 1 e a uno con 3).
 */
export function ColSpanInputPopover() {
  return (
    <ColSpanContentWrapper>
      <InfoPopoverText>
        Il <b>Numero colonne</b> determina la larghezza del campo quando si
        trova in una Riga: la riga si divide in proporzione al Numero colonne di
        ciascun campo che contiene. Esempi con valore <b>2</b>:
      </InfoPopoverText>
      <InfoPopoverExamplesGrid>
        <InfoPopoverExampleValueBox>
          <InfoPopoverExampleCaption>
            Accanto a un campo con valore 1, la Riga vale 3.
          </InfoPopoverExampleCaption>
          <ColSpanExampleTwoOne />
          <InfoPopoverExampleValue>Il campo occupa 2/3</InfoPopoverExampleValue>
        </InfoPopoverExampleValueBox>
        <InfoPopoverExampleValueBox>
          <InfoPopoverExampleCaption>
            Accanto a un campo con valore 3, la Riga vale 5.
          </InfoPopoverExampleCaption>
          <ColSpanExampleTwoThree />
          <InfoPopoverExampleValue>Il campo occupa 2/5</InfoPopoverExampleValue>
        </InfoPopoverExampleValueBox>
      </InfoPopoverExamplesGrid>
    </ColSpanContentWrapper>
  );
}
